import { render, staticRenderFns } from "./MdStatus.vue?vue&type=template&id=524c248a&scoped=true"
import script from "./MdStatus.vue?vue&type=script&lang=js"
export * from "./MdStatus.vue?vue&type=script&lang=js"
import style0 from "./MdStatus.vue?vue&type=style&index=0&id=524c248a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c248a",
  null
  
)

export default component.exports